import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';
import { format } from 'date-fns';

const initialState = {
  loading: false,
  driversList: []
};
const driversReducer = createSlice({
  name: 'drivers',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getDriversList(state, action) {
      let newList;
      if (action.payload?.data?.data) {
        newList = action.payload?.data?.data.map((item) => {
          return {
            ...item,
            driverLicenseNumber: item?.driverLicense?.number,
            driverLicenseExpiration: item?.driverLicense?.expiration
              ? format(item?.driverLicense?.expiration, 'MM/dd/yyyy')
              : '',
            driverLicenseState: item?.driverLicense?.state
          };
        });
      }
      return {
        ...state,
        driversList: newList,
        count: action.payload?.data?.count
      };
    },
    getDriverById(state, action) {
      return {
        ...state,
        driverInfo: action.payload?.data
      };
    }
  }
});

export default driversReducer.reducer;

export const DriversActions = driversReducer.actions;

export const createDriver = (data) => async () => {
  try {
    const res = await api.post(`api/Driver`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const editDriver = (data, id) => async () => {
  try {
    const res = await api.put(`api/Driver/${id}`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const getDriversAction = (data) => async (dispatch) => {
  dispatch(DriversActions.setLoading(true));
  try {
    const res = await api.get(`api/Driver`, { params: data });
    if (res.status === 200 && res?.data) {
      dispatch(DriversActions.getDriversList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(DriversActions.setLoading(false));
  }
};
export const getDriverById = (id) => async (dispatch) => {
  dispatch(DriversActions.setLoading(true));
  try {
    const res = await api.get(`api/Driver/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(DriversActions.getDriverById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(DriversActions.setLoading(false));
  }
};
export const clearDriverById = () => async (dispatch) => {
  dispatch(DriversActions.getDriverById(''));
};
export const removeDriverAction = (id, setRemoveDialog) => async (dispatch) => {
  try {
    const res = await api.delete(`api/Driver/${id}`);
    if (res.status === 200 && res?.data) {
      setRemoveDialog('');
      toast.success('Removed successfully!!!');
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
  }
};
